import {
  validateInitialReadingForNewMetersOnly,
  validateOverwriteIfMeterNameExists,
} from "../hooks"

export const getMetersImportConfig = ({
  spaces,
  products,
  meterNames,
  phaseTypes,
}) => {
  const fields = [
    {
      label: "Meter Name",
      key: "name",
      type: "string",
      validators: [
        { validate: "required" },
        {
          validate: "unique_case_insensitive",
          error: "Duplicate meter name in import",
        },
      ],
    },
    {
      label: "Space",
      key: "space_id",
      type: "select",
      selectOptions: spaces,
      validators: [{ validate: "required" }],
      description:
        "The space where this meter is installed. Reservations assigned to this space are eligible to be billed when a reading is recorded.",
    },
    {
      label: "Product",
      key: "product_id",
      type: "select",
      selectOptions: products,
      validators: [{ validate: "required" }],
      description:
        "The metered electric product used for billing. Its price per unit is applied to consumption when a reading is recorded.",
    },
    {
      label: "Voltage",
      key: "voltage",
      type: ["number", { preset: "integer", min: 1 }],
    },
    {
      label: "Amperage",
      key: "amperage",
      type: ["number", { preset: "integer", min: 1 }],
    },
    {
      label: "Phase Type",
      key: "phase_type",
      type: "select",
      selectOptions: [{ value: "", label: "" }, ...phaseTypes],
    },
    {
      label: "Overwrite",
      key: "overwrite",
      type: "checkbox",
      description:
        "For existing meters only, should the data in this import overwrite the existing meter's attributes with those provided here?",
    },
    {
      label: "Initial Reading",
      key: "initial_reading",
      type: "number",
      description:
        "For new meters only. Creates an initial metered electric reading.",
      validators: [
        {
          validate: "require_with",
          fields: ["initial_reading_date"],
          errorMessage:
            "Initial Reading is required when an Initial Reading Date is provided.",
        },
      ],
    },
    {
      label: "Initial Reading Date",
      key: "initial_reading_date",
      type: "date",
      description:
        "Date for the initial reading. Falls back to the current date if omitted.",
    },
  ]

  const rowHooks = [
    validateOverwriteIfMeterNameExists(meterNames),
    validateInitialReadingForNewMetersOnly(meterNames),
  ]

  return { fields, rowHooks }
}
